import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import WhyNeedSection from './components/WhyNeedSection';
import CTASection from './components/CTASection';
import BestExpertsSection from './components/BestExpertsSection';
import SupportSection from './components/SupportSection';
import OurServicesSection from './components/OurServicesSection';
import HowWeWorkSection from './components/HowWeWorkSection';
import PricingSection from './components/PricingSection';
import ProfessionalAssistanceSection from './components/ProfessionalAssistanceSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import ContactFormDialog from './components/ContactFormDialog';
import { Toaster } from './components/ui/toaster';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import TrademarkRegistration from './pages/services/TrademarkRegistration';
import CopyrightRegistration from './pages/services/CopyrightRegistration';
import CompanyFormation from './pages/services/CompanyFormation';
import TrademarkSearch from './pages/services/TrademarkSearch';
import AmazonBrandRegistry from './pages/services/AmazonBrandRegistry';

function HomePage() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);

  return (
    <div>
      <Header onOpenContactForm={() => setIsContactFormOpen(true)} />
      
      <HeroBanner />
      
      <WhyNeedSection onOpenContactForm={() => setIsContactFormOpen(true)} />
      
      <CTASection 
        onOpenContactForm={() => setIsContactFormOpen(true)}
        imagePosition="right"
        heading="US Trademark Registration | Register Trademark Online"
        paragraph="Professional trademark registration services with online trademark filing and federal trademark protection. Our trademark attorneys provide expert USPTO trademark application support, comprehensive trademark search services, and complete brand protection. Register a trademark today with affordable trademark registration services starting at $45. Get trademark lawyer consultation and secure your brand identity with our trademark legal services."
        buttonText="Register Trademark Online - $45"
        imageSrc="/section2.png"
      />
      
      <BestExpertsSection onOpenContactForm={() => setIsContactFormOpen(true)} />
      
      <CTASection 
        onOpenContactForm={() => setIsContactFormOpen(true)}
        imagePosition="left"
        heading="Amazon Brand Registry | Register Brand on Amazon"
        paragraph="Complete Amazon Brand Registry enrollment services with federal trademark registration for Amazon sellers. Our trademark attorneys provide Amazon seller brand registry setup, brand verification, trademark registration for Amazon, and comprehensive Amazon IP protection services. Register brand on Amazon with expert guidance to unlock A+ Content, sponsored brands advertising, and enhanced Amazon brand protection tools."
        buttonText="Enroll in Amazon Brand Registry"
        imageSrc="/section4.png"
      />
      
      <SupportSection />
      
      <OurServicesSection onOpenContactForm={() => setIsContactFormOpen(true)} />
      
      <HowWeWorkSection />
      
      <PricingSection onOpenContactForm={() => setIsContactFormOpen(true)} />
      
      <ProfessionalAssistanceSection />
      
      <WhyChooseUsSection onOpenContactForm={() => setIsContactFormOpen(true)} />
      
      <TestimonialsSection />
      
      <FAQSection />
      
      <Footer onOpenContactForm={() => setIsContactFormOpen(true)} />
      
      <ContactFormDialog
        isOpen={isContactFormOpen}
        onClose={() => setIsContactFormOpen(false)}
      />
      
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/services/trademark-registration" element={<TrademarkRegistration />} />
          <Route path="/services/copyright-registration" element={<CopyrightRegistration />} />
          <Route path="/services/company-formation" element={<CompanyFormation />} />
          <Route path="/services/trademark-search" element={<TrademarkSearch />} />
          <Route path="/services/amazon-brand-registry" element={<AmazonBrandRegistry />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
